import styled from 'styled-components';

export const StyledUserInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 1.5rem;
    border: 1px solid #CBCBCB;
    width: 400px;
    padding: 1.75rem;
    height: fit-content;
    box-sizing: border-box;

    @media (max-width: 1560px) {
        width: 350px;
    }

    @media (max-width: 1380px) {
        width: 300px;
    }

    @media (max-width: 1150px) {
        width: 100%;
    }
`

export const StyledUserInfoWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
`
export const StyledUserImageWrapper = styled.div`
    width: 100px;
    height: 100px;

    & img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        object-fit: cover;  
        border: 1px solid rgb(0, 0, 0);
        box-shadow: rgba(0, 0, 0, 0.2) 0px 6px 8px;
    }

    @media (max-width: 1150px) {
        flex: unset;
    }
`

export const StyledUserInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 60%;
    justify-content: space-around;
    width: fit-content;
`

export const StyledUserAddress = styled.h2`
    color: white;
    font-size: 24px;
    margin: 0;

    @media (max-width: 1380px) {
        font-size: 20px;
    }
`

export const StyledWalletInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
`

export const StyledButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
`